/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type FormModalHeaderProps = {
    title: React.ReactNode
    subtitle?: React.ReactNode
    bottom?: React.ReactNode
    actions?: React.ReactNode
    className?: string
}

const UiFormModalHeader: React.FC<FormModalHeaderProps> = ({
    title,
    subtitle,
    bottom,
    actions,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiFormModalHeader sticky top-0 px-6 pt-6 pb-6 z-20 transition-colors',
                'bg-white/80 backdrop-blur-md border-b border-gray-100 text-gray-900',
                'dark:bg-gray-950/80 dark:backdrop-blur-md dark:border-b dark:border-gray-800/50 dark:text-gray-100',
                className
            )}
        >
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                    <h2
                        className={clsx(
                            'text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-100'
                        )}
                    >
                        {title}
                    </h2>
                    {subtitle && (
                        <p
                            className={clsx(
                                'text-sm text-gray-600 mt-1 dark:text-gray-400'
                            )}
                        >
                            {subtitle}
                        </p>
                    )}
                </div>
                {actions && <div className="flex-none">{actions}</div>}
            </div>
            {bottom && <div className={clsx('mt-4')}>{bottom}</div>}
        </div>
    )
}

export default UiFormModalHeader
